import { lazy, Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LOCAL_STORAGE, Pages } from '../../constants/enums';
import useNetwork from '../../hooks/useNetwork';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import useApp from '../../hooks/useApp';
import ErrorIcon from '@mui/icons-material/Error';
import MainLoader from '../UI/MainLoader/MainLoader';
import { AdminPermissions } from '../../models/app';

const Overview = lazy(() => import('./Overview/Overview'));
const Listing = lazy(() => import('./Listing/Listing'));

const Dashboard: React.FC = () => {
  let { slug } = useParams();
  const { navigateTo } = useApp();
  const session = useSelector((state: any) => state.app.session);

  const accountsSelected = useSelector((state: any) => state.accounts.selected);
  const userPermissions: AdminPermissions = useSelector(
    (state: any) => state.app.userPermissions,
  );

  const featuresAllListing = useSelector(
    (state: any) => state.features.listingAll,
  );

  function checkFeature(slug: any): Boolean {
    let feature: any[] = [];
    if (accountsSelected && accountsSelected.features) {
      feature = featuresAllListing.filter(function (feature: any) {
        return (
          slug.toLowerCase() === feature.slug.toLowerCase() &&
          accountsSelected.features.indexOf(feature.id) !== -1
        );
      });
    }

    if (feature.length > 0) {
      return true;
    }

    return false;
  }

  const notAuthorized = () => {
    if (!session) {
      navigateTo(`/`);
    }
    return (
      <Grid
        item
        container
        alignContent={'center'}
        alignItems={'center'}
        justifyContent={'center'}
        justifyItems={'center'}
      >
        <Grid
          item
          xs={4}
          container
          alignContent={'center'}
          alignItems={'center'}
          justifyContent={'center'}
          justifyItems={'center'}
          marginTop={3}
        >
          <ErrorIcon sx={{ fontSize: 50 }} />
        </Grid>
        <Grid item xs={12}>
          <Typography
            align={'center'}
            marginTop={3}
            fontSize={25}
            fontFamily={'Raleway'}
          >
            Unauthorized Action
          </Typography>
        </Grid>
      </Grid>
    );
  };

  // const userConcepts: UserConcepts = useSelector(
  //   (state: any) => state.app.concepts,
  // );

  const conceptsSelected: string = useSelector(
    (state: any) => state.concepts.selected,
  );
  const { online } = useNetwork();

  const renderOffline = () => {
    if (!online) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '80vh',
          }}
        >
          <Box
            sx={{
              display: 'block',
              maxWidth: 200,
              height: 'auto',
              marginBottom: '40px',
            }}
            component="img"
            // src={networkErrorImage}
            alt="network-error"
          />
          <Typography variant="h4" component="h4" paragraph>
            You cant view admins when you're offline.
          </Typography>
          <Typography variant="h3" component="h1" paragraph>
            Connect to the internet
          </Typography>
          <Typography variant="h4" component="h3" paragraph>
            Check your connection. And Try again.
          </Typography>
          <Button
            variant="outlined"
            sx={{ mt: 6 }}
            size="large"
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
        </Box>
      );
    } else {
      return <Listing key={`${slug!}-${`${conceptsSelected}`}`} slug={slug!} />;
    }
  };
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userPermissions.admins === false) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 10000);
    } else {
      setLoading(false);
    }
  }, [userPermissions]);

  if (loading) return <MainLoader />;

  const renderContent = () => {
    // if (slug === Pages.GUESTS && !online)
    //   localStorage.setItem(LOCAL_STORAGE.GUESTS_SEARCH, 'true');
    switch (slug) {
      case Pages.ADMINS:
        return checkFeature(Pages.ADMINS) &&
          userPermissions.admins &&
          userPermissions.settings
          ? renderOffline()
          : notAuthorized();
      case Pages.DASHBOARD:
        return checkFeature(Pages.DASHBOARD) ? (
          <Overview key={`${conceptsSelected}`} slug={slug} />
        ) : (
          notAuthorized()
        );

      case Pages.ADMIN_ROLES:
        return checkFeature(Pages.ADMIN_ROLES) &&
          userPermissions.settings === true ? (
          <Listing key={`${slug}-${`${conceptsSelected}`}`} slug={slug} />
        ) : (
          notAuthorized()
        );
      case Pages.ADMIN_GROUPS:
        return checkFeature(Pages.ADMIN_GROUPS) &&
          userPermissions.settings === true ? (
          <Listing key={`${slug}-${`${conceptsSelected}`}`} slug={slug} />
        ) : (
          notAuthorized()
        );
      case Pages.CONCEPTS:
        return checkFeature(Pages.CONCEPTS) &&
          userPermissions.Concept_Access === true ? (
          <Listing key={`${slug}-${`${conceptsSelected}`}`} slug={slug} />
        ) : (
          notAuthorized()
        );
      case Pages.MESSAGING:
        return checkFeature(Pages.MESSAGING) &&
          userPermissions.Messaging_Access === true ? (
          <Listing key={`${slug}-${`${conceptsSelected}`}`} slug={slug} />
        ) : (
          notAuthorized()
        );
      case Pages.CONVERSATIONS:
        return checkFeature(Pages.CONVERSATIONS) &&
          userPermissions.Messaging_Access === true ? (
          <Listing key={`${slug}-${`${conceptsSelected}`}`} slug={slug} />
        ) : (
          notAuthorized()
        );
      case Pages.RESERVATIONS:
        return checkFeature(Pages.RESERVATIONS) &&
          userPermissions.Reservations_Access === true ? (
          <Listing key={`${slug}-${`${conceptsSelected}`}`} slug={slug} />
        ) : (
          notAuthorized()
        );
      default:
        return (checkFeature(slug) && userPermissions.admins) || true ? (
          <Listing key={`${slug!}-${`${conceptsSelected}`}`} slug={slug!} />
        ) : (
          notAuthorized()
        );
    }
  };

  return <Suspense fallback={<MainLoader />}>{renderContent()}</Suspense>;
};

export default Dashboard;
